module.exports = __webpack_public_path__ + "img/FR10548.1012fa38.png";